
<div class="apg-loading" *ngIf="loading">
  <p>{{message}}</p>
  <ion-spinner></ion-spinner>
</div> 
<div class="title" *ngIf="title && !loading">{{title}}</div>

<app-site-content [key]="errorKey" class="invalid-feedback d-block" *ngIf="errorKey"></app-site-content>

<div class="quick-quote-validate-otp" *ngIf="!loading && !errorKey"> 
  <p>
    {{sentMessage}}
  </p>
  <form [autocomplete]="false" (ngSubmit)="continue()" #otpForm="ngForm">
    <div class="text">
      <div class="text__label">
        <ion-label>Code</ion-label>
      </div>
      <div class="text-input-group" style="display:block">
        <div class="form-group">
          <input type="text" required pattern="^\d{5}$" [(ngModel)]="otp" name="otp" placeholder="Passcode"
            tabindex="0" autocomplete="one-time-code" autofocus="true"  [class.has-error]="error"  />
        </div>
      </div>
    </div>
    <div class="invalid-feedback d-block" *ngIf="submitted && error">{{error}}</div>

    <div class="summary__buttons" buttons>
      <ion-button (click)="onPrev()" slot="start">Previous</ion-button>
      <ion-button type="submit" [disabled]="otpForm.invalid" slot="end" tabindex="1">
        Continue
      </ion-button>
    </div>
  </form>
</div>

